import HttpRequest from "../http_request";

class BannerApi extends HttpRequest {
  apiGetBanner() {
    return this.fetch(`/client/v1/carousel-banner?status=active`);
  }
}

export default BannerApi;
